export function validEmail(value:string) {
    var regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
    if (value && !regex.test(value))
        return false;
    return true;
}

export function validPhone(value:string) {
    var regex = /^[\+0]\d{8,15}$/
    if (value && !regex.test(value))
        return false;
    return true;
}
